import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import React from 'react';
import Util from '../../Util';

interface CheckBoxProps {
    onChange?: Function
    buttonColor?: string
    buttonClassName?: string
    borderWidth?: number
    borderColor?: string
    borderOnColor?: string
    borderRadius?: number
    backgroundColor?: string
    checked?: boolean
    disabled?: boolean
}
function CheckBox({ onChange, buttonColor, buttonClassName, borderWidth, borderColor, borderOnColor, borderRadius, backgroundColor, checked, disabled }: CheckBoxProps) {
    const [hoverState, setHoverState] = React.useState<boolean>(false);
    const [focusState, setFocusState] = React.useState<boolean>(false);

    return (
        <button
            className={'p0 bdN ' + (buttonClassName ? buttonClassName : "") + (disabled ? " op60" : "")}
            onClick={(e) => {
                if (!onChange) {
                    return;
                }
                onChange(e);
            }}
            onFocus={() => setFocusState(true)}
            onBlur={() => setFocusState(false)}
        >
            {checked ?
                <div className="bdN w16 h16 p0" style={{
                    background: buttonColor,
                    borderRadius: borderRadius ? borderRadius + "px" : ""
                }}>
                    <DoneOutlinedIcon style={{width: "100%", height: "100%", color: "#fff"}} />
                </div>
            :
                <div
                    className="w16 h16 bd1 bsBdb"
                    style={{
                        borderWidth: borderWidth ? borderWidth : 1,
                        borderColor: (focusState || hoverState && !disabled ? (Util.isEmpty(borderOnColor) ? "#DDDDDD" : borderOnColor) : (Util.isEmpty(borderColor) ? "#DDDDDD" : borderColor)),
                        background: Util.isEmpty(backgroundColor) ? "white" : backgroundColor,
                        borderRadius: borderRadius ? borderRadius + "px" : ""
                    }}
                    onMouseOver={() => setHoverState(true)}
                    onMouseOut={() => setHoverState(false)}
                ></div>
            }
        </button>
    )
}
export default CheckBox;